/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-accent[_ngcontent-%COMP%]{border:1px solid #c2000f}@media screen and (min-width:768px){.renew-loader[_ngcontent-%COMP%]   .wrap[_ngcontent-%COMP%]{padding:0 30rem}}.renew-loader[_ngcontent-%COMP%]     .loading{margin:50px auto}"];
export { styles as styles };
